import { QueriesResults, useQueries, UseQueryResult } from '@tanstack/react-query';
import { useRouter } from 'next/router';

import { MemberBenefit, MemberInfo, MemberMypage, MemberPointBenefit } from '../interfaces';

import {
  getMemberInfo,
  getMemberPointBenefit,
  getMemberPoints,
  getMemberMypageInfo,
  getMemberBenefits,
} from '../services';
import { useAppSelector } from '../store';
import { getPointAllowedUrl, getBenefitsAllowedUrl } from '../utils/member';

import { memberKeys } from '../utils/queryKey';

interface Response {
  memberQueries: QueriesResults<[MemberInfo, number, MemberPointBenefit, MemberBenefit[], MemberMypage]>;
  memberInfoQuery: UseQueryResult<MemberInfo>;
  memberPointQuery: UseQueryResult<number>;
  currentBenefitQuery: UseQueryResult<MemberPointBenefit>;
  memberBenefitQuery: UseQueryResult<MemberBenefit[]>;
  mypageInfoQuery: UseQueryResult<MemberMypage>;
}

export default function useKurlyMember(): Response {
  const router = useRouter();

  const isGuest = useAppSelector(({ auth }) => auth.isGuest);

  const memberQueries = useQueries({
    queries: [
      {
        queryKey: memberKeys.memberInfo(),
        queryFn: getMemberInfo,
        enabled: !isGuest,
      },
      {
        queryKey: memberKeys.memberPoint(),
        queryFn: getMemberPoints,
        enabled: !isGuest && getPointAllowedUrl(router.pathname),
      },
      {
        queryKey: memberKeys.currentBenefit(),
        queryFn: getMemberPointBenefit,
        enabled: !isGuest,
      },
      {
        queryKey: memberKeys.memberBenefit(),
        queryFn: getMemberBenefits,
        enabled: !isGuest && getBenefitsAllowedUrl(router.pathname),
      },
      {
        queryKey: memberKeys.mypageInfo(),
        queryFn: getMemberMypageInfo,
        enabled: !isGuest,
      },
    ],
  });

  const [memberInfoQuery, memberPointQuery, currentBenefitQuery, memberBenefitQuery, mypageInfoQuery] = memberQueries;

  return {
    memberQueries,
    memberInfoQuery,
    memberPointQuery,
    currentBenefitQuery,
    memberBenefitQuery,
    mypageInfoQuery,
  };
}
